import i18next from "i18next";
import * as yup from "yup";

export function validation() {
  return yup.object().shape({
    description: yup
      .string()
      .optional()
      // .required(i18next.t("validation.createMemories.description"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    name: yup
      .string()
      .required(i18next.t("validation.createMemories.albumTitle"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    // date: yup.string().optional(),
    // .required(i18next.t("validation.createMemories.date")),
    memorialAlbumImage: yup.string().required("Album Image is required"),
  });
}
